import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";

const brandTheme = createTheme({ palette: { primary: { main: "#065F46" } } });

export function BlogBreadcrumbs({ items = [] }) {
  return (
    <ThemeProvider theme={brandTheme}>
    <Breadcrumbs sx={{ mb: 2, fontFamily: "Heebo" }}>
      {items.map((item, idx) =>
        item.href && idx < items.length - 1 ? (
          <Link
            key={idx}
            component={RouterLink}
            to={item.href}
            underline="hover"
            sx={{ color: "primary.main", fontFamily: "Heebo", fontSize: 14, "&:hover": { color: "primary.main" } }}
          >
            {item.label}
          </Link>
        ) : (
          <Typography key={idx} sx={{ color: "text.primary", fontFamily: "Heebo", fontSize: 14 }}>
            {item.label}
          </Typography>
        )
      )}
    </Breadcrumbs>
    </ThemeProvider>
  );
}
